import { DamageRptConstants } from "../constants/DamageRptConstants";

export function DamageRpt(state = {}, action) {
    switch (action.type) {
        case DamageRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case DamageRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case DamageRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case DamageRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case DamageRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case DamageRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case DamageRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}